import { Box, Button, Typography } from "@mui/material";
import { ArticlesList } from "components/blog/articles-list";
import {
  BookOpenText,
  Bot,
  CalendarSync,
  CodeXml,
  Download,
  Map,
  SquareScissors,
} from "lucide-react";
import { useHistory } from "react-router-dom";
import * as Routes from "routes";
import ItemCard from "./hub-card";

export const HubPage = () => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: "32px",
        paddingTop: "0px",
        paddingBottom: "32px",
        paddingX: "32px",
        maxWidth: "100%",
      }}
    >
      <ActionMenu />
      <WhatsNewPreview />
    </Box>
  );
};

const ActionMenu = () => {
  const actions = [
    {
      id: 1,
      title: "Explore",
      path: Routes.dataExplorer,
      icon: <Map size={36} color="#4CAF50" />,
    },
    {
      id: 2,
      title: "Clip",
      path: Routes.clipUi,
      icon: <SquareScissors size={36} color="#ED6C02" />,
    },
    {
      id: 3,
      title: "Download",
      path: Routes.dataDownload,
      icon: <Download size={36} color="#1976D2" />,
    },
    {
      id: 4,
      title: "Batch",
      path: Routes.batchBatches,
      icon: <Bot size={36} color="#E91E63" />,
    },
    {
      id: 5,
      title: "App",
      path: Routes.developerApiKeys,
      icon: <CodeXml size={36} color="#9C27B0" />,
    },
    {
      id: 6,
      title: "Docs",
      path: Routes.docsPage,
      icon: <BookOpenText size={36} color="#607D8B" />,
    },
    {
      id: 7,
      title: "Subscription",
      path: Routes.orgSubscription,
      icon: <CalendarSync size={36} color="#8BC34A" />,
    },
  ];

  const history = useHistory();

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: "16px",
        width: "100%",
      }}
    >
      <Typography variant="h5" fontWeight={800}>
        Shortcuts
      </Typography>

      <Box
        sx={{
          display: "flex",
          gap: "16px",
          justifyContent: "center",
          alignItems: "center",
          flexWrap: "wrap",
          width: "100%",
        }}
      >
        {actions.map((item, id) => (
          <ItemCard item={item} id={id} key={id} />
        ))}
      </Box>
    </Box>
  );
};

const WhatsNewPreview = () => {
  const history = useHistory();

  const handleArticleClick = (identifier: string) => {
    history.push(`/whats-new/${identifier}`);
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: "16px",
        width: "100%",
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Typography variant="h5" fontWeight={800}>
          Whats New
        </Typography>
        <Button variant="text" onClick={() => history.push(Routes.whatsNew)}>
          View All
        </Button>
      </Box>

      <ArticlesList limit={4} onArticleClick={handleArticleClick} />
    </Box>
  );
};
